/**
 * Smart Add-ons — quantity steppers + "add both to cart" for the Best Combo card.
 * Paired with snippets/best-combo.liquid + snippets/smart-addon-combo-card.liquid.
 * (snippets/smart-addons.liquid — "Complete the combo" — is now a plain product grid using
 * the theme's native slider-component, so it no longer needs this script or a carousel here.)
 */
(function () {
  function getLiveSourceVariantId(fallbackId) {
    // Prefer the variant currently selected on the main product form (shopper may have
    // switched pack size since page load) — the smart-addons metafield is product-level,
    // so the pair list itself doesn't change, but the "current product" line item should
    // still reflect whatever variant is selected right now.
    var input = document.querySelector('product-form form[id^="product-form-"] [name="id"]');
    if (input && input.value) return input.value;
    return fallbackId;
  }

  function setStatus(root, message) {
    var status = root && root.querySelector('[data-smart-addons-status]');
    if (status) status.textContent = message;
  }

  function getQuantityFor(card, variantId) {
    var input = card.querySelector('[data-smart-addon-qty-input][data-variant-id="' + variantId + '"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  /* ---- Money formatting (derived from an already-rendered price, no format guessing) ---- */

  // Builds a formatter for this card's currency by diffing its server-rendered source-price
  // text against the known cents value behind it — avoids hand-rolling Shopify's money_format
  // parsing or depending on a global (this theme exposes no JS money-format helper).
  function buildMoneyFormatter(card) {
    var sample = card.querySelector('[data-smart-addon-price-sample]');
    var sourceCents = parseInt(card.dataset.sourcePrice, 10);
    if (!sample || !sourceCents) return null;

    var sampleText = sample.textContent;
    var digitsOnly = String(Math.trunc(sourceCents / 100));
    var decimalPart = sourceCents % 100;
    var decimalStr = (decimalPart < 10 ? '0' : '') + decimalPart;

    // Find where the integer part's digits sit in the sample text, using both possible
    // decimal separators, so we can split the string into prefix / separator / suffix.
    var separators = [',', '.'];
    for (var i = 0; i < separators.length; i++) {
      var sep = separators[i];
      var needle = digitsOnly + sep + decimalStr;
      var index = sampleText.indexOf(needle);
      if (index !== -1) {
        var prefix = sampleText.slice(0, index);
        var suffix = sampleText.slice(index + needle.length);
        return function (cents) {
          var whole = String(Math.trunc(Math.abs(cents) / 100));
          var decimals = Math.abs(cents) % 100;
          var decimalsStr = (decimals < 10 ? '0' : '') + decimals;
          var sign = cents < 0 ? '-' : '';
          return sign + prefix + whole + sep + decimalsStr + suffix;
        };
      }
    }
    return null;
  }

  /* ---- Live recompute (combo total + free-shipping badge/note) ---- */

  // Re-derives the combo total from the two quantity inputs currently in the card and
  // updates the total text + free-shipping badge/note — so adjusting either stepper reflects
  // immediately, matching what the server originally computed for the default quantities.
  function recomputeCard(card) {
    var sourceCents = parseInt(card.dataset.sourcePrice, 10) || 0;
    var addonCents = parseInt(card.dataset.addonPrice, 10) || 0;
    var thresholdRaw = card.dataset.shippingThreshold;
    var threshold = thresholdRaw ? parseInt(thresholdRaw, 10) : null;

    var sourceInput = card.querySelector('[data-smart-addon-quantity-role="source"] [data-smart-addon-qty-input]');
    var addonInput = card.querySelector('[data-smart-addon-quantity-role="addon"] [data-smart-addon-qty-input]');
    var sourceQty = sourceInput ? parseInt(sourceInput.value, 10) || 1 : 1;
    var addonQty = addonInput ? parseInt(addonInput.value, 10) || 1 : 1;

    var total = sourceCents * sourceQty + addonCents * addonQty;

    var totalEl = card.querySelector('[data-smart-addon-total] strong');
    if (totalEl) {
      var formatMoney = buildMoneyFormatter(card);
      if (formatMoney) totalEl.textContent = formatMoney(total);
    }

    var qualifies = threshold !== null && total >= threshold;
    var badge = card.querySelector('[data-smart-addon-badge]');
    if (badge) badge.hidden = !qualifies;
    var shippingNote = card.querySelector('[data-smart-addon-shipping-note]');
    if (shippingNote) shippingNote.hidden = !qualifies;
  }

  /* ---- Quantity steppers ---- */

  function initQuantitySteppers(root) {
    root.querySelectorAll('[data-smart-addon-quantity]').forEach(function (stepper) {
      if (stepper.dataset.smartAddonQtyBound) return;
      stepper.dataset.smartAddonQtyBound = 'true';

      var input = stepper.querySelector('[data-smart-addon-qty-input]');
      var decrease = stepper.querySelector('[data-smart-addon-qty-decrease]');
      var increase = stepper.querySelector('[data-smart-addon-qty-increase]');
      var card = stepper.closest('[data-smart-addon-pair]');

      function clamp(value) {
        var min = parseInt(input.min, 10) || 1;
        return value < min ? min : value;
      }

      function update(value) {
        input.value = clamp(value);
        if (card) recomputeCard(card);
      }

      decrease.addEventListener('click', function () {
        update((parseInt(input.value, 10) || 1) - 1);
      });
      increase.addEventListener('click', function () {
        update((parseInt(input.value, 10) || 1) + 1);
      });
      input.addEventListener('change', function () {
        update(parseInt(input.value, 10) || 1);
      });
    });
  }

  /* ---- Add both to cart ---- */

  function handleAddBoth(event) {
    var button = event.currentTarget;
    if (button.getAttribute('aria-disabled') === 'true') return;

    var card = button.closest('[data-smart-addon-pair]');
    var root = button.closest('[data-smart-addons-root]');
    var sourceId = getLiveSourceVariantId(button.dataset.sourceVariantId || (root && root.dataset.sourceVariantId));
    var addonId = button.dataset.addonVariantId;

    var sourceQty = card ? getQuantityFor(card, sourceId) : 1;
    var addonQty = card ? getQuantityFor(card, addonId) : 1;

    var items = [];
    if (sourceId) items.push({ id: sourceId, quantity: sourceQty });
    if (addonId) items.push({ id: addonId, quantity: addonQty });

    if (items.length < 2) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden', 'spinning-complete');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.data && (result.data.description || result.data.message)) || '';
          setStatus(
            root,
            (window.strings && window.strings.smartAddons && window.strings.smartAddons.error) ||
              message ||
              'Unable to add these products to cart.'
          );
          return;
        }

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.reload();
          cartDrawer.open(button);
        } else {
          window.location.href = window.routes.cart_url || '/cart';
        }

        setStatus(
          root,
          (window.strings && window.strings.smartAddons && window.strings.smartAddons.added) || 'Added to your cart.'
        );
      })
      .catch(function () {
        setStatus(
          root,
          (window.strings && window.strings.smartAddons && window.strings.smartAddons.error) ||
            'Unable to add these products to cart.'
        );
      })
      .finally(function () {
        button.setAttribute('aria-disabled', 'false');
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden', 'spinning-complete');
      });
  }

  function initAddButtons(root) {
    root.querySelectorAll('[data-smart-addon-add]').forEach(function (button) {
      if (button.dataset.smartAddonBound) return;
      button.dataset.smartAddonBound = 'true';
      button.addEventListener('click', handleAddBoth);
    });
  }

  function init() {
    document.querySelectorAll('[data-smart-addons-root]').forEach(function (root) {
      initQuantitySteppers(root);
      initAddButtons(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // product-info.js's variant-switch AJAX patch (handleUpdateProductInfo) replaces the
  // innerHTML of #best-combo-<sectionId> with freshly-rendered markup for the newly-selected
  // variant — brand new DOM nodes with no listeners bound yet. It publishes
  // PUB_SUB_EVENTS.variantChange right after; re-running init() there binds the new nodes
  // (their per-element data-*Bound guards are naturally absent on fresh nodes, so this is
  // safe to call repeatedly).
  if (!window.smartAddonsVariantChangeSubscribed && typeof subscribe === 'function') {
    window.smartAddonsVariantChangeSubscribed = true;
    subscribe(PUB_SUB_EVENTS.variantChange, init);
  }
})();
